/**
 * aida-spa
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpContext 
        }       from '@angular/common/http';
import { Observable }                                        from 'rxjs';
import { OpenApiHttpParams, QueryParamStyle } from '../query.params';

// @ts-ignore
import { MessagesBodyDTO } from '../model/messagesBodyDTO';
// @ts-ignore
import { PaginatedSpaBookingDTO } from '../model/paginatedSpaBookingDTO';
// @ts-ignore
import { SpaBookingDTO } from '../model/spaBookingDTO';
// @ts-ignore
import { SpaBookingNoteUpdateDTO } from '../model/spaBookingNoteUpdateDTO';
// @ts-ignore
import { SpaBookingOrdersDTO } from '../model/spaBookingOrdersDTO';
// @ts-ignore
import { SpaBookingResultsDTO } from '../model/spaBookingResultsDTO';
// @ts-ignore
import { SpaTicketUpdateDTO } from '../model/spaTicketUpdateDTO';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';



@Injectable({
  providedIn: 'root'
})
export class BookingsService extends BaseService {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * Creates a new booking. 
     * @endpoint post /rest/v1/spa/bookings
     * @param spaBookingOrdersDTO 
     * @param assignEmployeesRoomsAutomatically Automatically assign employee/room as required for all tickets.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public createBookings(spaBookingOrdersDTO: SpaBookingOrdersDTO, assignEmployeesRoomsAutomatically?: boolean, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<SpaBookingResultsDTO>;
    public createBookings(spaBookingOrdersDTO: SpaBookingOrdersDTO, assignEmployeesRoomsAutomatically?: boolean, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<SpaBookingResultsDTO>>;
    public createBookings(spaBookingOrdersDTO: SpaBookingOrdersDTO, assignEmployeesRoomsAutomatically?: boolean, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<SpaBookingResultsDTO>>;
    public createBookings(spaBookingOrdersDTO: SpaBookingOrdersDTO, assignEmployeesRoomsAutomatically?: boolean, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (spaBookingOrdersDTO === null || spaBookingOrdersDTO === undefined) {
            throw new Error('Required parameter spaBookingOrdersDTO was null or undefined when calling createBookings.');
        }

        let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'assignEmployeesRoomsAutomatically',
            <any>assignEmployeesRoomsAutomatically,
            QueryParamStyle.Form,
            false,
        );


        let localVarHeaders = this.defaultHeaders;

        // authentication (sessionAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('sessionAuth', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/rest/v1/spa/bookings`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<SpaBookingResultsDTO>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: spaBookingOrdersDTO,
                params: localVarQueryParameters.toHttpParams(),
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Returns the booking with the given ID 
     * @endpoint get /rest/v1/spa/bookings/{bookingId}
     * @param bookingId The booking ID.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public getBookingById(bookingId: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<SpaBookingDTO>;
    public getBookingById(bookingId: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<SpaBookingDTO>>;
    public getBookingById(bookingId: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<SpaBookingDTO>>;
    public getBookingById(bookingId: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (bookingId === null || bookingId === undefined) {
            throw new Error('Required parameter bookingId was null or undefined when calling getBookingById.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (sessionAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('sessionAuth', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/rest/v1/spa/bookings/${this.configuration.encodeParam({name: "bookingId", value: bookingId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<SpaBookingDTO>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Retrieves the bookings that match the given parameters. 
     * @endpoint get /rest/v1/spa/bookings
     * @param guestId the ID of the guest
     * @param fromDate Restricts the returned bookings to contain at least one ticket having from-date greater equal to the given.
     * @param toDate Restricts the returned bookings to contain at least one ticket having to-date less equal to the given.
     * @param page Zero based index of the page to return
     * @param size Number of elements to return per page
     * @param sort Property and direction for sorting the results
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public getBookings(guestId?: string, fromDate?: string, toDate?: string, page?: number, size?: number, sort?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<PaginatedSpaBookingDTO>;
    public getBookings(guestId?: string, fromDate?: string, toDate?: string, page?: number, size?: number, sort?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<PaginatedSpaBookingDTO>>;
    public getBookings(guestId?: string, fromDate?: string, toDate?: string, page?: number, size?: number, sort?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<PaginatedSpaBookingDTO>>;
    public getBookings(guestId?: string, fromDate?: string, toDate?: string, page?: number, size?: number, sort?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {

        let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'guestId',
            <any>guestId,
            QueryParamStyle.Form,
            false,
        );


        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'fromDate',
            <any>fromDate,
            QueryParamStyle.Form,
            false,
        );


        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'toDate',
            <any>toDate,
            QueryParamStyle.Form,
            false,
        );


        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'page',
            <any>page,
            QueryParamStyle.Form,
            false,
        );


        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'size',
            <any>size,
            QueryParamStyle.Form,
            false,
        );


        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'sort',
            <any>sort,
            QueryParamStyle.Form,
            false,
        );


        let localVarHeaders = this.defaultHeaders;

        // authentication (sessionAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('sessionAuth', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/rest/v1/spa/bookings`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<PaginatedSpaBookingDTO>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters.toHttpParams(),
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Retrieves the bookings for the given guest(-ID). 
     * @endpoint get /rest/v1/spa/guests/{guestId}/bookings
     * @param guestId the ID of the guest
     * @param fromDate Restricts the returned bookings to contain at least one ticket having from-date greater equal to the given.
     * @param toDate Restricts the returned bookings to contain at least one ticket having to-date less equal to the given.
     * @param page Zero based index of the page to return
     * @param size Number of elements to return per page
     * @param sort Property and direction for sorting the results
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public getGuestBookings(guestId: string, fromDate?: string, toDate?: string, page?: number, size?: number, sort?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<PaginatedSpaBookingDTO>;
    public getGuestBookings(guestId: string, fromDate?: string, toDate?: string, page?: number, size?: number, sort?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<PaginatedSpaBookingDTO>>;
    public getGuestBookings(guestId: string, fromDate?: string, toDate?: string, page?: number, size?: number, sort?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<PaginatedSpaBookingDTO>>;
    public getGuestBookings(guestId: string, fromDate?: string, toDate?: string, page?: number, size?: number, sort?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (guestId === null || guestId === undefined) {
            throw new Error('Required parameter guestId was null or undefined when calling getGuestBookings.');
        }

        let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'fromDate',
            <any>fromDate,
            QueryParamStyle.Form,
            false,
        );


        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'toDate',
            <any>toDate,
            QueryParamStyle.Form,
            false,
        );


        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'page',
            <any>page,
            QueryParamStyle.Form,
            false,
        );


        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'size',
            <any>size,
            QueryParamStyle.Form,
            false,
        );


        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'sort',
            <any>sort,
            QueryParamStyle.Form,
            false,
        );


        let localVarHeaders = this.defaultHeaders;

        // authentication (sessionAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('sessionAuth', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/rest/v1/spa/guests/${this.configuration.encodeParam({name: "guestId", value: guestId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/bookings`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<PaginatedSpaBookingDTO>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters.toHttpParams(),
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Retrieves a check/receipt either for a single ticket or a whole booking.
     * @endpoint get /rest/v1/spa/bookings/guest-checks
     * @param bookingId 
     * @param calendarItemId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public getGuestCheck(bookingId?: string, calendarItemId?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/pdf' | 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<Blob>;
    public getGuestCheck(bookingId?: string, calendarItemId?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/pdf' | 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Blob>>;
    public getGuestCheck(bookingId?: string, calendarItemId?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/pdf' | 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Blob>>;
    public getGuestCheck(bookingId?: string, calendarItemId?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/pdf' | 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {

        let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'bookingId',
            <any>bookingId,
            QueryParamStyle.Form,
            false,
        );


        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'calendarItemId',
            <any>calendarItemId,
            QueryParamStyle.Form,
            false,
        );


        let localVarHeaders = this.defaultHeaders;

        // authentication (sessionAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('sessionAuth', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/pdf',
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let localVarPath = `/rest/v1/spa/bookings/guest-checks`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters.toHttpParams(),
                responseType: "blob",
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Updates the notes of a booking.
     * @endpoint put /rest/v1/spa/bookings/{bookingId}/note
     * @param bookingId The booking ID.
     * @param spaBookingNoteUpdateDTO 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public updateBookingNote(bookingId: string, spaBookingNoteUpdateDTO: SpaBookingNoteUpdateDTO, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<SpaBookingDTO>;
    public updateBookingNote(bookingId: string, spaBookingNoteUpdateDTO: SpaBookingNoteUpdateDTO, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<SpaBookingDTO>>;
    public updateBookingNote(bookingId: string, spaBookingNoteUpdateDTO: SpaBookingNoteUpdateDTO, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<SpaBookingDTO>>;
    public updateBookingNote(bookingId: string, spaBookingNoteUpdateDTO: SpaBookingNoteUpdateDTO, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (bookingId === null || bookingId === undefined) {
            throw new Error('Required parameter bookingId was null or undefined when calling updateBookingNote.');
        }
        if (spaBookingNoteUpdateDTO === null || spaBookingNoteUpdateDTO === undefined) {
            throw new Error('Required parameter spaBookingNoteUpdateDTO was null or undefined when calling updateBookingNote.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (sessionAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('sessionAuth', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/rest/v1/spa/bookings/${this.configuration.encodeParam({name: "bookingId", value: bookingId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/note`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<SpaBookingDTO>('put', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: spaBookingNoteUpdateDTO,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Selectively updates tickets of a booking. Tickets not contained in the request remain unchanged.
     * @endpoint put /rest/v1/spa/bookings/{bookingId}/tickets
     * @param bookingId The booking ID.
     * @param spaTicketUpdateDTO 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public updateBookingTickets(bookingId: string, spaTicketUpdateDTO: Array<SpaTicketUpdateDTO>, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<SpaBookingDTO>;
    public updateBookingTickets(bookingId: string, spaTicketUpdateDTO: Array<SpaTicketUpdateDTO>, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<SpaBookingDTO>>;
    public updateBookingTickets(bookingId: string, spaTicketUpdateDTO: Array<SpaTicketUpdateDTO>, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<SpaBookingDTO>>;
    public updateBookingTickets(bookingId: string, spaTicketUpdateDTO: Array<SpaTicketUpdateDTO>, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (bookingId === null || bookingId === undefined) {
            throw new Error('Required parameter bookingId was null or undefined when calling updateBookingTickets.');
        }
        if (spaTicketUpdateDTO === null || spaTicketUpdateDTO === undefined) {
            throw new Error('Required parameter spaTicketUpdateDTO was null or undefined when calling updateBookingTickets.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (sessionAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('sessionAuth', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/rest/v1/spa/bookings/${this.configuration.encodeParam({name: "bookingId", value: bookingId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/tickets`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<SpaBookingDTO>('put', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: spaTicketUpdateDTO,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

}
